var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 104,
    viewBox: "0 0 30 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(-2525 4367)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M15,0,30,26H0Z",
    transform: "translate(2555 -4341) rotate(180)",
    fill: "#d63a60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M15,0,30,26H0Z",
    transform: "translate(2555 -4315) rotate(180)",
    fill: "#d63a60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M15,0,30,26H0Z",
    transform: "translate(2555 -4289) rotate(180)",
    fill: "#d63a60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M15,0,30,26H0Z",
    transform: "translate(2555 -4263) rotate(180)",
    fill: "#d63a60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow2);
export default __webpack_public_path__ + "static/media/downArrow2.f3da9c1f495e783b40a7c2c977aa4665.svg";
export { ForwardRef as ReactComponent };